import { createContext } from "react";

export const SDialogContext = createContext<Function>(() => {});
